import type { PropsWithChildren } from 'react';

import { TourProvider as ReactTourProvider } from '@reactour/tour';

import { TourContextProvider, useTourContext } from '@/shared/lib/context';
import { TourStep } from '@/shared/ui/tour-step';
import { TourWelcomeModal } from '@/shared/ui/tour-welcome-modal';

function TourContent(props: PropsWithChildren) {
    const { children } = props;
    const { modal } = useTourContext();

    return (
        <>
            {children}
            {modal && (
                <TourWelcomeModal
                    contentKey={modal.config.contentKey}
                    imageAlt={modal.config.imageAlt}
                    imageSrc={modal.config.imageSrc}
                    isOpen={modal.isOpen}
                    onClose={modal.closeHandler}
                    onStartTour={modal.startHandler}
                    titleKey={modal.config.titleKey}
                />
            )}
        </>
    );
}

export function TourProvider(props: PropsWithChildren) {
    const { children } = props;

    return (
        <ReactTourProvider
            ContentComponent={TourStep}
            // disableInteraction
            onClickMask={() => {}}
            padding={{ popover: 2 }}
            scrollSmooth
            steps={[]}
        >
            <TourContextProvider>
                <TourContent>{children}</TourContent>
            </TourContextProvider>
        </ReactTourProvider>
    );
}
